export default "__VITE_ASSET__df5e6f9c__"